{
  "title": "Title",
  "sub_title": "Sub title",
  "notes": "Notes",
  "contact": "Contact",
  "location_submit": "Submit location",
  "field_required": "Field is required",
  "meeting_point": "Meeting point",
  "add_location": "Add location",
  "update_location": "Update location",
  "line1_label": "Line 1",
  "line2_label": "Line 2",
  "city_label": "City",
  "state_label": "State",
  "zipCode_label": "ZIP Code",
  "zipCode_error": "ZIP Code must be a number of 4 digits or more",
  "country_label": "Country",
  "address": "Address",
  "error_location": "An error has occurred while displaying location",
  "created_at": "Created at",
  "expires_at": "Expires at"
}
